import React, { ReactNode } from 'react'
import { Switch, Divider, InputNumber, Select } from '@arco-design/web-react'
import { useSelector, useDispatch } from 'react-redux'
import useLocale from '../../hooks/useLocale'
import styles from './style/block.module.less'
import { updateSettings } from '@/store/slices/appSlice'

export interface BlockProps {
  title?: ReactNode
  options?: {
    name: string
    value: string
    type?: 'switch' | 'number' | 'select'
    options?: Array<any>
  }[]
  children?: ReactNode
}

export default function Block(props: BlockProps) {
  const { title, options, children } = props
  const locale = useLocale()
  const settings = useSelector((state) => state['app'].settings)
  const dispatch = useDispatch()

  return (
    <div className={styles.block}>
      <h5 className={styles.title}>{title}</h5>
      {options &&
        options.map((option) => {
          const type = option.type || 'switch'

          return (
            <div className={styles['switch-wrapper']} key={option.value}>
              <span>{locale[option.name]}</span>
              {type === 'switch' && (
                <Switch
                  size="small"
                  checked={!!settings[option.value]}
                  onChange={(checked) => {
                    const newSetting = {
                      ...settings,
                      [option.value]: checked,
                    }
                    dispatch(updateSettings(newSetting))
                    // set color week
                    if (checked && option.value === 'colorWeek') {
                      document.body.style.filter = 'invert(80%)'
                    }
                    if (!checked && option.value === 'colorWeek') {
                      document.body.style.filter = 'none'
                    }
                  }}
                />
              )}
              {type === 'number' && (
                <InputNumber
                  style={{ width: 100 }}
                  size="small"
                  value={settings[option.value]} //settings.menuWidth}
                  onChange={(value) => {
                    const newSetting = {
                      ...settings,
                      [option.value]: value,
                    }
                    dispatch(updateSettings(newSetting))
                  }}
                />
              )}
              {type === 'select' && (
                <Select
                  style={{ width: 100 }}
                  size="small"
                  value={settings[option.value]}
                  options={option.options}
                  onChange={(value) => {
                    const newSetting = {
                      ...settings,
                      [option.value]: value,
                    }
                    dispatch(updateSettings(newSetting))
                  }}
                />
              )}
            </div>
          )
        })}
      {children}
      <Divider />
    </div>
  )
}

